import { Alignment } from "@mcleod/core";
import { Component, Label, LabelProps, Textbox } from "../..";
import { TooltipSource } from "../../page/tooltips/TooltipSource";
import { ListLayoutLauncherProps } from "../../page/ListLayoutLauncher";

export class PrintableLabel extends Label {
    private parentComponent: Component;

    constructor(parentComponent: Component, labelProps?: Partial<LabelProps>) {
        super(labelProps);
        this.parentComponent = parentComponent;
        this._designer = parentComponent._designer;
        this.alternateDesignerTarget = parentComponent;
        this.syncId();
    }

    public syncId() {
        this.id = this.parentComponent.createInnerComponentId("printableLabel");
    }

    get nullDisplayValue(): string {
        if (this.parentComponent instanceof Textbox) {
            return this.parentComponent.nullDisplayValue;
        }
        return super.nullDisplayValue;
    }

    set nullDisplayValue(value: string) {
        super.nullDisplayValue = value;
    }

    override get tooltipSources(): TooltipSource[] {
        return this.parentComponent.tooltipSources;
    }

    override get tooltipPosition(): Alignment {
        return this.parentComponent.tooltipPosition;
    }

    override get listLayoutLauncherProps(): ListLayoutLauncherProps {
        if (this.parentComponent instanceof Textbox) {
            return this.parentComponent.listLayoutLauncherProps;
        }
        return super.listLayoutLauncherProps;
    }
}
